/// <amd-module name="Widgets/CumulativeFlowDiagram/BoardsUtils" />
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";

/**
 * Retrieves a URL to a board.
 * @param project is the project the board is associated with
 * @param teamId is the name or ID of a team the board is associated with
 * @param backlogLevel is the name or category reference name of the board
 */
export function createBoardUrl(pageContext: IVssPageContext, project: string, team: string, backlogLevel: string): string {
    return routeUrl(pageContext, "ms.vss-work-web.team-board-content-route", {
        project,
        teamName: team,
        backlogLevel,
        pivot: "board"
    });
}
